import styles from './style.postcss';
import React from 'react';
import classnames from 'classnames';
import { pure } from 'recompose';
import { testClass } from 'omni-common-ui';
import PropTypes from 'prop-types';

const Cell = (props, { header }) => {
  const {
    children,
    colSpan,
    rowSpan,
    small,
    highlighted,
    relativePosition,
    className,
    style,
    onlyRowDivider,
  } = props;

  const highlightedClass = classnames(styles.__highlighted, testClass('highlighted'));
  const classes = classnames(styles.SimpleTable_cell, testClass('table-cell'), className, {
    [styles.__small]: small,
    [highlightedClass]: highlighted,
    [styles.__relative]: relativePosition,
    [styles.__onlyRowDivider]: onlyRowDivider,
  });
  if (header === true) {
    return <th colSpan={colSpan}
        rowSpan={rowSpan}
        className={classes}
        style={style}>
      {children}
    </th>;
  }

  return <td colSpan={colSpan} rowSpan={rowSpan} className={classes} style={style}>{children}</td>;
};

Cell.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  colSpan: PropTypes.number,
  rowSpan: PropTypes.number,
  small: PropTypes.bool,
  highlighted: PropTypes.bool,
  onlyRowDivider: PropTypes.bool,
  relativePosition: PropTypes.bool,
  style: PropTypes.shape(),
};

Cell.contextTypes = {
  header: PropTypes.bool,
};

export default pure(Cell);



// WEBPACK FOOTER //
// ./components/SimpleTable/Cell.jsx